import src from "IMAGE";
export default { src, width: 979, height: 250, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAO0lEQVR42j3IsREAEAxA0bCRjk0M4JDCDio2TtIFRRT/7t8DVYUXEQFija2XwMxg/ueiGwPT2jOLiDc/aSIptaOgX1wAAAAASUVORK5CYII="};
